import React, { useState } from 'react';
import { Row, Col } from "react-bootstrap";
import Typography from '@mui/material/Typography';
import { Stack, TextField, Button } from "@mui/material";
import { apiContactPageClient } from "./service/ApiClient"; 

import "./styles/ContactUs.css";

// const sendEmailURL = "https://tmbt9488pd.execute-api.us-east-1.amazonaws.com/prod/contactus"

const ContactUs= () => {
  
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [formStatus, setFormStatus] = useState('')
  
  const onSubmit = (e) => {
    e.preventDefault()
    setFormStatus('Submitting...')

    if  (name.trim() === '' || email.trim() === '' || message.trim() === '') {
      setFormStatus('Please provide all information');
      return;
    }
    setFormStatus(null);

    const payload = {
        name,
        email,
        message,
    };
   
    apiContactPageClient.post("/", payload).then(response => {
      setFormStatus('Message sent.');
      console.log(response);
    }).catch(error => {
        if (error.response.status === 401 || error.response.status === 403) {
            setFormStatus(error.response.data.message);
        } else{
            setFormStatus('sorry... the backend server is down!! please try again later');
        }
    })
  };

  return (
    <div className="contactus-page">
        <Stack spacing={2}>
            <Row>
			    <Col>
                    <Typography variant="h4" gutterBottom class="text-center" ><b>Contact Us</b></Typography>
                    <form onSubmit={onSubmit} class="my-5">
                        <Stack direction='column' spacing={2}>
                            <TextField label='name' type='text' onChange={event => setName(event.target.value)}/>
                            <TextField label='email' type='text' onChange={event => setEmail(event.target.value)}/>
                            <TextField label='message' type='text' multiline onChange={event => setMessage(event.target.value)}/>
                            {/* <Button variant="contained" type="submit">SEND</Button> */}
                            <Button variant="contained" class="btn-teal" type="submit">Send</Button>
                        
                        </Stack>
                    </form>
                    {formStatus && <p className="errorMessage">{formStatus}</p>}
                    <br></br>
                </Col>
			</Row>
        </Stack>
    </div>
  );
};
export default ContactUs